import React from "react";
import { Link } from "react-router-dom";
import { FaTwitter, FaLinkedin, FaGithub, FaEnvelope } from "react-icons/fa";
import "./Footer.scss";
import { AimLogoBlack } from "../icons/AimLogoBlack";
import { FooterLogo } from "../icons/FooterLogo";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <div className="footer-brand">
            <AimLogoBlack />
            <p className="mt-[30px] text-base text-[#17150B]">
              Not just another email tool - this is conversational AI that
              understands context, personality, and intent
            </p>
          </div>
          <div className="social-links">
            <a href="#" aria-label="Twitter" className="social-link">
              <FaTwitter />
            </a>
            <a href="#" aria-label="LinkedIn" className="social-link">
              <FaLinkedin />
            </a>
            <a href="#" aria-label="GitHub" className="social-link">
              <FaGithub />
            </a>
            <a
              href="mailto:support@aimagents.ai"
              aria-label="Email"
              className="social-link"
            >
              <FaEnvelope />
            </a>
          </div>
        </div>

        <div className="footer-links">
          <div className="footer-column">
            <h4>Company</h4>
            <ul>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
              <li>
                <Link to="/careers">Careers</Link>
              </li>
              <li>
                <Link to="/partners">Partners</Link>
              </li>
            </ul>
          </div>
          <div className="footer-column">
            <h4>Resources</h4>
            <ul>
              <li>
                <Link to="/docs">Documentation</Link>
              </li>
              <li>
                <Link to="/blog">Blog</Link>
              </li>
              <li>
                <Link to="/tutorials">Tutorials</Link>
              </li>
              <li>
                <Link to="/api">API Reference</Link>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Social</h4>
            <ul>
              <li>
                <Link to="/terms-of-service">Discord</Link>
              </li>
              <li>
                <Link to="/security">Linkedin</Link>
              </li>
              <li>
                <Link to="/compliance">Twitter(X)</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom flex-col">
        <div className="flex flex-col sm:flex-row justify-between items-center">
          <p>&copy; {currentYear} AIM Agents. All rights reserved.</p>
          <ul>
            <li>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/terms-of-service">Terms of Service</Link>
            </li>
            <li>
              <Link to="/security">Security</Link>
            </li>
            <li>
              <Link to="/compliance">Compliance</Link>
            </li>
          </ul>
        </div>
        <div className="w-full mt-8">
          <FooterLogo className="w-full" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
